const _ = require('underscore');
const React = require("react");
const createReactClass = require("create-react-class");

const form = require('../../../deploynaut/js/Form.jsx');

const RaygunForm = createReactClass({
	getInitialState: function() {
		const state = {
			id: null,
			apiKey: "",
			authToken: ""
		};

		const integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.apiKey = integration.options.APIKey;
			state.authToken = integration.options.AuthToken;
		}

		return state;
	},

	render() {
		return (
			<div className="integration-form">
				<p>
					Enabling the <a href='https://raygun.com' target="_new">Raygun</a> integration will send completed
					deployments to your <a href='https://raygun.com' target="_new">Raygun</a> application, which appear
					alongside your Crash Reporting error chart to see how particular
					deployments are performing.
				</p>

				<form.Form
					ref="raygunForm"
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="APIKey">API Key</label>
						<form.Input
							name="APIKey"
							required
							validationError="Please enter a valid API key belonging to an application"
							placeholder="API Key"
							value={this.state.apiKey}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="AccessToken">External Access Token</label>
						<form.Input
							name="AuthToken"
							required
							validationError="Please enter your External Access Token"
							placeholder="External Access Token"
							value={this.state.authToken}
						/>
					</div>


					<form.Hidden name="Type" value="Raygun" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			</div>
		);
	}
});

module.exports = RaygunForm;
